import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    color: theme.palette.text.primary,
    fontFamily: "Nunito Sans",
  },
  inlineDiv: {
    width: "60%",
    flexWrap: "wrap",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "20px",
  },
  filter: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    backgroundColor: "#464283",
    border: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: "10px",
    padding: "8px 12px",
  },

  plusIcon: {
    width: "28px",
    height: "19px",
  },
  sequencePageNewSequenceButton: {
    backgroundColor: theme.palette.secondary.main,
    height: "40px",
    borderRadius: "10px",
    fontSize: "14px",
    padding: "12px",
    color: theme.palette.text.secondary,
  },
}));

export default useStyles;
